import React, { FC } from 'react';
import { FormInputCheckbox } from '../../inputs/FormInputCheckbox';

interface AdditionalOptionsProps {
  onChangeAdditionalService?: (e: boolean) => void;
  defaultChecked?: boolean;
  isDisabled?: boolean;
  registerFormName: string;
  label: string;
}

const defaultProps = {
  defaultChecked: false,
  isDisabled: false,
  onChangeAdditionalService: undefined,
};

export const AdditionalOptions: FC<AdditionalOptionsProps> = ({
  defaultChecked,
  isDisabled,
  onChangeAdditionalService,
  registerFormName,
  label,
}) => {
  return (
    <div className={`payment__content__options__additional__item ${isDisabled ? 'idle' : ''}`}>
      <div key="additional">
        <FormInputCheckbox
          onChange={onChangeAdditionalService}
          name={registerFormName}
          defaultChecked={defaultChecked}
          label={label}
        />
      </div>
    </div>
  );
};

AdditionalOptions.defaultProps = defaultProps;
